import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useAuth } from '../../features/auth/AuthContext';
import { fetchNotifications } from '../../features/notifications/api/notifications';
import { NOTIFICATIONS } from '../../constants/testIds';

const MEMBER_ROLES = ['member', 'vip', 'mentor', 'sales'];

export function NotificationBell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const isAdmin = !!user && user.roles.includes('admin');
  const isMemberArea = !!user && user.roles.some((r) => MEMBER_ROLES.includes(r));
  const active = isAdmin || isMemberArea;

  useEffect(() => {
    if (!active) return;
    let alive = true;
    const load = () => fetchNotifications(isAdmin).then((d) => { if (alive) setCount(d.unread_count); }).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    window.addEventListener('notifications:changed', load);
    return () => { alive = false; clearInterval(id); window.removeEventListener('notifications:changed', load); };
  }, [active, isAdmin]);

  if (!active) return null;

  return (
    <button
      data-testid={NOTIFICATIONS.bell}
      onClick={() => navigate(isAdmin ? '/admin/notifications-inbox' : '/member/notifications')}
      className="relative w-10 h-10 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] flex items-center justify-center transition-colors"
      aria-label="Notifikasi"
    >
      <Bell className="w-5 h-5 text-white/70" strokeWidth={1.5} />
      {count > 0 && (
        <span data-testid={NOTIFICATIONS.badge} className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-cyan-400 text-[#050914] text-[10px] font-semibold flex items-center justify-center">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}
